import type { PageType } from '@sportworld/js-sdk/src/types/servicesTypes/pageTypes'

import useStore from '@/store/useStore'

export const useDataWidgetTeamId = () => {
  const { page } = useStore((state) => state.page)
  const { pagePopup } = useStore((state) => state.popup)
  const { dataExtension } = pagePopup || page || ({} as PageType)

  return dataExtension?.teamId
}
